import React, { useContext } from 'react';
import { PageTabsContext } from 'util/PageTabs';
import { PermissionGatedRoutesContext } from 'util/PermissionGatedRoutesContext';
import UsersTable from './UsersTable/UsersTable';
import RoleRouteMapping from './RoleRouteMapping';

const UserManagement = () => {
  const activeTab = useContext(PageTabsContext);
  const permissionGatedRoutes = useContext(PermissionGatedRoutesContext) || [];

  if (activeTab === 'roles-routes') {
    return <RoleRouteMapping routes={permissionGatedRoutes} />;
  }

  return <UsersTable userType={activeTab} />;
};

export default UserManagement;
